import { GET_EXPERIENCE,ADD_EXPERIENCE, UPDATE_EXPERIENCE, DELETE_EXPERIENCE } from '../actions/actionTypes';

const initialState = {
  expcardItemData:[],exptotalCount:0,expcardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).startDate;

  console.log('date1',date1);

  return date1;
}


export default function experience(state = initialState, action) {

  switch (action.type) {
     case GET_EXPERIENCE:
      
      return{
       ...state,
       expcardData: action.getCardData,
       exptotalCount:action.totalCount,
       expcardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
      case ADD_EXPERIENCE:


      console.log("Action in add work experience", action)

      if(!action.newlyAddedWorkExperience) {
        //work experience could not be added, just return back the state
        return {
          ...state
        }
      }

      let updatedWorkExperiences = state.expcardItemData
      updatedWorkExperiences.push(action.newlyAddedWorkExperience)

      let totalCount=0
      let finaldata=[]
      let setCardItemDataShow=false


      totalCount = updatedWorkExperiences.length

      let getCardItemData = updatedWorkExperiences.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

      if(totalCount > 3) {
        setCardItemDataShow = true
      }


      if(getCardItemData.length > 0) {
        for (let i = 0; i < getCardItemData.length; i++) {
          const data = getCardItemData[i].newdata;
          let datecheck = checkdate(data);

          getCardItemData[i]['datecheck'] = datecheck;

          //restricted i.e. if work experience is publically viewable logic goes here. Add that logic if needed

          ///handling logic
        }
      }


      let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

      finaldata = getCardItemData2
      
      return{
       ...state,
       opentost: action.opentost,
       tost_msg: action.tost_msg,
       expcardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,
       exptotalCount: totalCount, 
       cardItemDataShow: setCardItemDataShow,
       expcardData: action.getCardData 

      };

      case UPDATE_EXPERIENCE:
        if(!action.updatedWorkExperienceItem) {
          return {
            ...state
          }
        } 
        const matchingWorkExpItemIndex = state.expcardItemData.findIndex(workExpItem => workExpItem.id === action.updatedWorkExperienceItem.id)

        if(matchingWorkExpItemIndex !== -1) {
          state.expcardItemData[matchingWorkExpItemIndex] = action.updatedWorkExperienceItem
        }


        return {
          ...state
        }

      case DELETE_EXPERIENCE:
        console.log("Delete work experience reducer")
        if(action.deleteSuccess) {
          console.log("Delete was successful")
          const workExpAfterDelete = action.expCardItemData  
          console.log("workExpAfterDelete", workExpAfterDelete)
  
          let totalCountAfterDelete=0;
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;
  
          totalCountAfterDelete = workExpAfterDelete.length
  
          let cardItemsData = workExpAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  
          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }
  
          if(cardItemsData.length > 0) {
            for (let i = 0; i < cardItemsData.length; i++) {
              const data = cardItemsData[i].newdata;
              let datecheck = checkdate(data);
    
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }
  
          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))
    
          finaldataAfterDelete = cardItemsData2
  
          return {
            ...state,
            expcardItemData: finaldataAfterDelete,
            exptotalCount: totalCountAfterDelete,  
            cardItemDataShow: setCardItemDataShowAfterDelete,
          }
        } else {
          //delete was not successful
          console.log("Work experience Delete was not successful")
          return {
            ...state
          }
        }
        

    default: return state;
  }
};

